import { Injectable } from '@angular/core';
import { GitQuery } from '@y42/git';
import { BehaviorSubject, combineLatest, finalize, map } from 'rxjs';
import { AbstractJobService } from '../../api/job.service';
import { JobStoreModel } from '../../state';
import { FinalJobStatuses } from '../../state/job-status';
import { JobQuery } from '../../state/job.query';

@Injectable()
export class JobCancellationButtonService {
  constructor(
    private readonly gitQuery: GitQuery,
    private readonly jobService: AbstractJobService,
    private readonly jobQuery: JobQuery,
  ) {}

  private readonly cancellationTriggered$$ = new BehaviorSubject(false);

  selectJob(id: JobStoreModel['request_id']) {
    return this.jobQuery.selectEntity(id);
  }

  selectCanCancel(id: JobStoreModel['request_id']) {
    return combineLatest([this.gitQuery.activeBranchName$, this.selectJob(id)]).pipe(
      map(([activeBranchName, job]) => {
        return job ? job.request.storage.branch === activeBranchName && !FinalJobStatuses.includes(job.status) : false;
      }),
    );
  }

  selectCancellationInProgress(id: JobStoreModel['request_id']) {
    return combineLatest([this.cancellationTriggered$$, this.jobService.selectIsJobCanceling(id)]).pipe(
      map(([cancellationInitiated, cancellationInProgress]) => cancellationInitiated || cancellationInProgress),
    );
  }

  cancelJob(id: JobStoreModel['request_id'], path: JobStoreModel['path']) {
    this.cancellationTriggered$$.next(true);
    return this.jobService.cancelJob(id, path).pipe(
      finalize(() => {
        this.cancellationTriggered$$.next(false);
      }),
    );
  }
}
